import viaPlayer from './player';
import elementAppend from 'cross-browser-polyfill/src/polyfills/element-append'; // https://www.npmjs.com/package/cross-browser-polyfill
elementAppend()

// const processedCalls = [];
const calls = IS_FLYADS ? 'flyPlayerCalls' : 'vadsPlayerCalls';

window.vadsPlayerController = window.vadsPlayerController || {};
window.vadsCheckPlayerQueueInterval = setInterval(() => {
  if (window[calls]) {
    const unprocessedCalls = window[calls].filter(
      (call) => !call.processed
    );
    
    unprocessedCalls.forEach((call) => {
      const { params } = call;
      const { zone, container } = params;
      
      const latestProcessedZoneCall = window[calls].filter((call) => call.params.zone === zone && call.processed).sort((a, b) => b.processedTime - a.processedTime)[0];
      
      if (latestProcessedZoneCall && (Date.now() - latestProcessedZoneCall.processedTime < 1000)) {
      } else if (window.vadsPlayerController === "undefined" || !window.vadsPlayerController.hasOwnProperty(zone)) {
        // new vadsPlayer(params);
        new viaPlayer(params);
        // processedCalls.push(call);
      } else if (!window.vadsPlayerController[zone].isRunning()) {
        window.vadsPlayerController[zone].start(params);
      } else {
        const playerSlot = document.querySelector(`[data-vads-zone="${zone}"]`)
        
        if (playerSlot && container.contains(playerSlot)) {
          console.log('prevented multiple player start');
        } else {
          // console.log('move zone to container ', container);
          
          window.vadsPlayerController[zone].stop();
          setTimeout(() => {
            window.vadsPlayerController[zone].start(params);
          }, 50);
        }
        
        // container.appendChild(playerSlot);
      }
      
      call.processed = true;
      call.processedTime = Date.now();
    });
  }
}, 250);

window.vadsPlayer = viaPlayer;
window.vadsPlayerCaller && window.vadsPlayerCaller.length && (window.vadsPlayerCaller.forEach((call) => new viaPlayer(call)));
